// .dashboard. ze względu na kompatybilność wstecz (nie trzeba orać wszystkich projektów)
angular.module('ihestiaWidgets.dashboard.euaChecker', [
    'ihestiaWidgets.dashboard'
  ])
  .run(['ihestiaEuaCheckerHelper', function(ihestiaEuaCheckerHelper) {
    ihestiaEuaCheckerHelper.checkForDocuments();
  }]);